import csvDownload from 'json-to-csv-export';
export function parseEuropeanNumber(input: string, euNumberFormat: boolean) {
  if (!euNumberFormat) {
    return Number(input);
  }
  const euNumber = input.replace(' ', '').replace('.', '').replace(',', '.');
  return Number(euNumber);
}
export function convertToEuropeanNumber(number: number | string, euNumberFormat = true) {
  if (typeof number === 'string') {
    return euNumberFormat ? number.replace('.', ',') : number;
  } else if (typeof number === 'number') {
    return euNumberFormat
      ? number.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: false })
      : number.toString();
  }
}

export const CSVHEADERS = {
  date: 'Datum',
  assetValueDevelopment: 'Asset Wertentwicklung',
  rentalSurplusIndexed: 'Mietüberschuss Indexiert',
  loanBalance: 'Kredit Saldo',
  interest: 'Zinsen',
  repayment: 'Tilgung',
  fees: 'Gebühren',
};

interface ICashflowCsvData {
  date: string;
  assetValueDevelopment: string;
  rentalSurplusIndexed: string;
  loanBalance: string;
  interest: string;
  repayment: string;
  fees: string;
}

export function downloadCashflowCsv(data: ICashflowCsvData[]) {
  const dataToConvert = {
    data: data,
    filename: 'Cashflow.csv',
    delimiter: ';',
    headers: Object.values(CSVHEADERS),
  };
  csvDownload(dataToConvert);
}
